import { Injectable } from '@angular/core';

import { BaseReferenceService } from './base';

@Injectable({
  providedIn: 'root',
})
export class MoistureReferenceService extends BaseReferenceService {
  constructor() {
    super('MoistureReference');
  }
}
